export default function swDev() {
    if ('serviceWorker' in navigator) {
        if (
            process.env.NODE_ENV !== 'production' ||
            window.location.hostname === 'localhost' ||
            window.location.hostname === '127.0.0.1'
        ) {
            navigator.serviceWorker.getRegistrations().then(registrations => {
                for (const registration of registrations) {
                    registration.unregister();
                }
            });
            if (typeof window !== 'undefined' && 'caches' in window) {
                caches.keys().then(keys => {
                    keys.forEach(key => caches.delete(key));
                });
            }
            return;
        }

        let swUrl = `${process.env.PUBLIC_URL}/serviceWorker.js`;
        navigator.serviceWorker
            .register(swUrl)
            .then(response => {})
            .catch(err => {});
    }
}
